export default __webpack_public_path__ + "static/media/r-urci.d4ff8c1a.png";